import { useEffect, useRef } from 'react';

import noop from 'lodash/noop';

interface UseIntervalEffectOptions {
  millisecondsPerInterval: number;
  numberOfIntervals?: number;
}

/**
 * Use this hook to repeat an effect at a regular interval.
 */
export function useIntervalEffect(
  callback: () => void,
  { millisecondsPerInterval, numberOfIntervals }: UseIntervalEffectOptions
): void {
  const savedCallback = useRef<() => void>(noop);

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    const interval = setInterval(() => {
      savedCallback.current();
    }, millisecondsPerInterval);

    let timeout: number | null;
    if (numberOfIntervals) {
      timeout = window.setTimeout(() => {
        window.clearInterval(interval);
      }, millisecondsPerInterval * numberOfIntervals);
    }

    return () => {
      window.clearInterval(interval);
      if (timeout) window.clearTimeout(timeout);
    };
  }, [millisecondsPerInterval, numberOfIntervals]);
}
